import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';

import {Observable} from 'rxjs';
import {catchError} from 'rxjs/operators';

import {ErrorService, EventService, StatusResponse} from '..';

import {ConfigService} from './config.service';
import {ProjectImage, UpdateProjectImageRequest} from "../models";


@Injectable({providedIn: 'root'})
export class ProjectImageService {
  private baseURL = ConfigService.getApiEndpoint() + 'v1/image/project/';

  constructor(
    private http: HttpClient,
    private eventService: EventService,
    private error: ErrorService
  ) {
  }

  get(projectId: string): Observable<ProjectImage> {
    return this.http.get<ProjectImage>(this.baseURL + projectId );
  }

  update(request: UpdateProjectImageRequest, projectId: string): Observable<ProjectImage> {
    return this.http.post<ProjectImage>(this.baseURL + projectId, request).pipe(
      catchError(this.error.handleError('projectImage.create', null))
    );
  }

  delete(projectId: string): Observable<StatusResponse> {
    return this.http.delete<StatusResponse>(this.baseURL + projectId).pipe(
      catchError(this.error.handleError('projectImage.delete', null))
    );
  }

}
